import {Component, EventEmitter, forwardRef, inject, Input, Output} from '@angular/core';
import {Match} from '../../../../../../model/events/Match';
import {FrontendService} from '../../../../../../services/frontend.service';
import {ErrorType} from '../../../../../../model/error-type';
import {LoadingService} from '../../../../../../services/loading.service';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {MatchreportService} from '../../../../../shared/service/matchreport.service';
import {MATCH_DETAILS_TAB_INFO} from '../event-match-details.component';
import { LoadingComponent } from '../../../../../../components/generic/loading/loading.component';
import { MessageComponent } from '../../../../../../components/generic/message/message.component';
import { EventPhaseMatchlistComponent } from '../../event-phase/event-phase-matchlist/event-phase-matchlist.component';

@Component({
    selector: 'app-event-match-report',
    templateUrl: './event-match-report.component.html',
    styleUrls: ['./event-match-report.component.scss'],
    standalone: true,
    imports: [LoadingComponent,
      MessageComponent,
      forwardRef(() => EventPhaseMatchlistComponent)
    ]
})
export class EventMatchReportComponent
{
  private frontendService = inject(FrontendService);
  private restErrorHelper = inject(RestErrorHelper);
  private matchreportService = inject(MatchreportService);

  loading = new LoadingService();
  errorMsg: ErrorType;

  @Input() databaseId: number;
  @Input() positionTop: number;
  matchIntern: Match;
  @Input() set match(value: Match)
  {
    this.matchIntern = value;
    this.loadData();
  }
  @Output() changeTab = new EventEmitter<any>();
  matches: Match[];
  @Input() firstTabInitialization: boolean;

  private loadData(): void
  {
    console.log('loadData(), databaseId: ' + this.databaseId + ', match: ', this.matchIntern);
    this.loading.isLoading = true;
    this.frontendService.getEventSubMatches(this.databaseId, this.matchIntern.eventId,
      this.matchIntern.id).subscribe({
      next: data =>
      {
        console.log('Spielbericht erhalten', data);
        this.matchreportService.initMatchReportBlock(data);
        this.matches = data;
        this.loading.isLoading = false;
        this.checkSelectedTab();
      },
      error: error =>
      {
        console.log('error', error);
        this.loading.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  private checkSelectedTab(): void
  {
    if (this.firstTabInitialization)
    {
      const hasParticipants = this.matches?.filter(m => m.participantHome && m.participantGuest).length > 0;
      console.log('checkSelectedTab, hasParticipants: ' + hasParticipants);
      if (!hasParticipants)
        this.changeTab.emit(MATCH_DETAILS_TAB_INFO);
      this.firstTabInitialization = false;
    }
  }
}
